import AuthDrawer from "../../components/AuthDrawer";
import useCallDataApi from "../../hooks/data";
import {useContext, useEffect, useState} from "react";
import {
    Avatar,
    Box,
    Card,
    CardActions,
    CardContent,
    FormControl,
    Grid, InputLabel, MenuItem, Select,
    Stack,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import Loading from "../../components/Loading";
import Button from "@mui/material/Button";
import {stringAvatar} from "../../utils/miscUtils";
import {useHistory} from "react-router-dom";
import {
    Person as PersonIcon,
    OpenInNew as OpenInNewIcon,
    CalendarToday as CalendarTodayIcon,
    AccessTime as AccessTimeIcon
} from '@mui/icons-material';
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {hu} from "date-fns/locale";
import AuthContext from "../../context/AuthContext";


const SavedCommissions = () => {
    const queryParams = JSON.parse(localStorage.getItem('savedCommissionQuery') || "{}")
    const {getData: getUsers} = useCallDataApi('users')
    const {getData: getSavedCommissions, postData: postSavedCommissions} = useCallDataApi('saved-commissions')
    const {getData: getDepartments} = useCallDataApi('departments')
    const [departments, setDepartments] = useState([])
    const [selectedDepartment, setSelectedDepartment] = useState(queryParams?.selectedDepartment || 1)
    const [commissions, setCommissions] = useState([])
    const [loading, setLoading] = useState(true)
    const today = new Date()
    const [searchQuery, setSearchQuery] = useState(queryParams?.searchQuery || '')
    const [fromDate, setFromDate] = useState(new Date(queryParams?.fromDate) || new Date(`${today.getFullYear()}-01-01`))
    const [endDate, setEndDate] = useState(new Date(queryParams?.endDate) || today)
    const history = useHistory()
    const {user} = useContext(AuthContext)

    document.title = 'Ügyintézői jutalék'

    useEffect(() => {
        const getData = async () => {
            setLoading(true)
            const [d] = await Promise.all([
                getDepartments(),
            ])
            if (d) setDepartments(d)
        }
        getData()
            .catch(r => console.log(r))
            .finally(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const saveToLocalStorage = () => {
        const savedQuery = {
            searchQuery,
            fromDate,
            endDate,
            selectedDepartment
        };
        localStorage.setItem('savedCommissionQuery', JSON.stringify(savedQuery));
    };

    useEffect(() => {
        const getData = async () => {
            setLoading(true)
            let data = {search: searchQuery, fromDate: fromDate, endDate: endDate, department: selectedDepartment};
            if (user.role === 'sales') data = {}
            const [ c] = await Promise.all([
                postSavedCommissions('search/', data)
            ])
            if (c) {
                setCommissions(c)
            }
        }
        saveToLocalStorage()
        getData()
            .catch(r => console.log(r))
            .finally(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery, fromDate, endDate, selectedDepartment])

    const handleOpenCommission = (commission) => {
        history.push(`/saved-commission/${commission?.id}`)
    }

    // const getUser = id => users.find(u => u?.id === id)

    const Search = () => {
        return <Stack direction='row' alignItems='center' gap={2}>
            <TextField variant='standard' placeholder='Név tartalmazza...' value={searchQuery}
                       onChange={e => setSearchQuery(e.target.value)}/>
            {/*<Button variant='contained' onClick={() => setSearchQuery('')} startIcon={<SearchOffRoundedIcon/>}>Keresés törlése</Button>*/}
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={hu}>
                <Stack spacing={2} direction='row' alignItems='center'>
                    <DatePicker
                        inputFormat="yyyy-MM-dd"
                        mask='____-__-__'
                        value={fromDate}
                        onChange={(v) => setFromDate(v)}
                        renderInput={(params) => <TextField name='from_date' variant='standard' {...params} />}
                    />
                    <Typography variant='body1' color='#38556A'>-</Typography>
                    <DatePicker
                        inputFormat="yyyy-MM-dd"
                        mask='____-__-__'
                        value={endDate}
                        onChange={(v) => setEndDate(v)}
                        renderInput={(params) => <TextField name='until_date' variant='standard' {...params} />}
                    />
                </Stack>
            </LocalizationProvider>
            <FormControl variant="standard" sx={{ minWidth: 150 }}>
                <Select
                    value={selectedDepartment}
                    onChange={e => setSelectedDepartment(e.target.value)}
                    label="Department"
                >
                    {departments.map(department => (
                        <MenuItem key={department.id} value={department.id}>
                            {department.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Stack>
    }

    return <AuthDrawer label='Mentett ügyintézői jutalék'>
        {user.role !== 'sales' && <Stack direction='row' justifyContent='space-between'
                sx={{background: '#fff', borderRadius: '8px', padding: '5px'}} marginBottom={2}>
            {Search()}
        </Stack>}
        <Grid container spacing={2}>
            {commissions?.map(c => <Grid key={c.id} item xs={12} md={6} xl={6}>
                <Card sx={{maxWidth: 400, m: 2, p: 2, boxShadow: 3}}>
                    <CardContent>
                        <Stack direction="row" spacing={3} alignItems="center">
                            <Avatar {...stringAvatar(c?.user_data?.name)} sx={{width: 70, height: 70}}/>
                            <Box>
                                <Typography variant="h6" color="primary" sx={{display: 'flex', alignItems: 'center'}}>
                                    {c?.user_data?.name}
                                </Typography>
                                <Typography variant="body2" color="textSecondary"
                                            sx={{display: 'flex', alignItems: 'center'}}>
                                    <CalendarTodayIcon sx={{mr: 1}}/>
                                    {c?.year}-{c?.month}
                                </Typography>
                                <Typography variant="body2" color="textSecondary"
                                            sx={{display: 'flex', alignItems: 'center'}}>
                                    <AccessTimeIcon sx={{mr: 1}}/>
                                    Mentve: {c?.saved_at}
                                </Typography>
                            </Box>
                        </Stack>
                    </CardContent>
                    <CardActions sx={{justifyContent: 'flex-end'}}>
                        <Button
                            variant="outlined"
                            onClick={() => handleOpenCommission(c)}
                            startIcon={<OpenInNewIcon/>}
                        >
                            Megnyitás
                        </Button>
                    </CardActions>
                </Card>
            </Grid>)}
        </Grid>

        <Loading isLoading={loading}/>

    </AuthDrawer>
}

export default SavedCommissions